"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    reportFilters: {
        section: 'Section',
        resultsFrom: 'Results from',
        module: 'Module',
        assessment: 'Assessment',
        generateReport: 'Generate Report',
    },
};
